import React from 'react';
import { getPortfolioItem } from "../../api/portfolio/PortfolioData";

import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import ButtonDefault from "../../components/button/button-default/ButtonDefault";
import BoxImageVertical from "../../components/box-image-vertical/BoxImageVertical";
import { Container } from "react-bootstrap";
import FadeUpTrigger from "../../animation/FadeUpTrigger";
import TextTrigger from "../../animation/TextTrigger";
import DsnGrid from "../../components/DsnGrid";
//--> Component
import HeaderHalf from "../../components/header/HeaderHalf";
import TitleCover from "../../components/heading/title-cover/TitleCover";
import ButtonProject from "../../components/button/button-project/ButtonProject";
import NextProject from "../../components/next/NextProject";
import BoxRight from "../../components/box-right/BoxRight";
import ParallaxImage from "../../components/parallax-image/ParallaxImage";
import { Helmet } from 'react-helmet-async';


const Annex = ({ data }) => {

    const nextData = getPortfolioItem(6);


    return (
        <React.Fragment>
            <Helmet>
                <title>Devlift - {data.title} </title>
                <link rel='canonical' href='/portolio/the-annex' />
                <meta
                    name="description"
                    content={data.description}
                />
            </Helmet>
            {/*Start Header Half*/}
            <HeaderHalf heroContent={data}
                overlay={data.overlay}
                href="#"
            >
                {/* <strong className="color-heading">Published </strong> <span> - July 15th 2019 </span> */}
            </HeaderHalf>
            {/*End Header Half*/}

            {/*Start Info Project*/}
            <Container className="section-margin">
                <TitleCover>The Ask</TitleCover>
                <TextTrigger duration={0.8} stagger={0.1}>
                    {(ref) => <h2 className="title-section" ref={ref}>The Ask</h2>}
                </TextTrigger>
                <FadeUpTrigger>
                    <p className="mt-20">
                        The Annex neighbourhood is considered Toronto’s most heterogeneous community, with a youthful vibrancy and a hip urban feel. The team at the Annex Hotel asked the Devlift team to help create an online presence that speaks to travelers in an intimate way, the antithesis of big-box multinational hotel chains.
                    </p>
                    <p className="mt-20">
                        The Annex team had already implemented a digital infrastructure that completely eliminated the front desk, admin and other operating expenses, while increasing guest satisfaction. Together, with Devlift’s help, they wanted to further create a digital experience that fit their ideology of selling a lifestyle - not shelter.
                    </p>
                </FadeUpTrigger>
            </Container>
            {/*End Info Project*/}



            {/*Start Grid Project*/}
            <Container className="section-margin">
                <DsnGrid col={1} colGap={50} rowGap={50} colGapTablet={30} rowGapTablet={30}>
                    <img src="/assets/img/project/annex/screenshot4.png" alt="" />
                </DsnGrid>
            </Container>
            {/*Start Grid Project*/}



            {/*Start Box Info With Image*/}
            <BoxImageVertical src="/assets/img/project/annex/header.png" className="section-margin">
                <FadeUpTrigger>
                    {(ref) => <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
                        <TitleCover>The Solution</TitleCover>
                        <h2 className='title-section border-line-left' ref={ref}>The Solution</h2>
                        <p ref={ref}>
                            Devlift worked together with The Annex team to create a design and experience that would celebrate the neighborhood and hotel, by bringing the community into their spaces.
                        </p>
                        <p ref={ref}>
                            With over 50% bookings completed directly on the website, The Annex had an existing partnership with a backend hospitality system that automated all hotel operations. Therefore, any new digital user experience implementations, had to integrate seamlessly with the existing backend operations.  The Devlift team successfully leveraged available technology and created an engaging digital experience across all devices that seamlessly integrated with the booking backend system and supported The Annex’s business objectives.
                        </p>
                        {/* <div className="button-box" ref={ref}>
                            <ButtonDefault text="launch" icon={faAngleRight} href="#0"/>
                        </div> */}

                    </DsnGrid>}
                </FadeUpTrigger>
            </BoxImageVertical>

            <Container className="section-margin">
                <DsnGrid col={1} colGap={50} rowGap={50} colGapTablet={30} rowGapTablet={30}>
                    <img src="/assets/img/project/annex/screenshot3.png" alt="" />
                </DsnGrid>
            </Container>


            <NextProject heroContent={nextData} overlay={nextData.overlay} />


        </React.Fragment>
    );
}


export default Annex;